export function calculateDynamicPayment(pv: number): number {
  if (pv > 1750) {
    return 150; // R$ 150 para valores acima de R$ 1.750
  }
  return 100; // R$ 100 para valores até R$ 1.750
}